import { render, staticRenderFns } from "./PagamentoInfo.vue?vue&type=template&id=3b39f592"
import script from "./PagamentoInfo.vue?vue&type=script&lang=js"
export * from "./PagamentoInfo.vue?vue&type=script&lang=js"
import style0 from "./PagamentoInfo.vue?vue&type=style&index=0&id=3b39f592&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports